import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { StudentAssignmentModel } from "./student-assignment-data.model";

export class StudentAssignmentGridPostParams extends GridPostParams {
    
}

export class StudentAssignmentGridModel extends StudentAssignmentModel { }

export class StudentAssignmentListingModel extends GridModel<StudentAssignmentGridModel> {
}
